import { render } from "./VoucherReplenishmentAlert.vue?vue&type=template&id=4487e006&scoped=true"
import script from "./VoucherReplenishmentAlert.vue?vue&type=script&lang=js"
export * from "./VoucherReplenishmentAlert.vue?vue&type=script&lang=js"

import "./VoucherReplenishmentAlert.vue?vue&type=style&index=0&id=4487e006&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\Erp Con api propia\\ERP CON MI-API\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4487e006"]])

export default __exports__